import { endpoint } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'interest';

/**
 * Interest Modal Endpoints:
 *     - Default Interest Endpoint.
 *     - Custom Interest Endpoint.
 */
export default {
    /**
     * Default Interest Calculation Modals.
     *
     * @return {Promise}
     */
    default: data => endpoint(`${PARENT}/${RESOURCE}`, 'default', data),
    /**
     * Custom Interest Calculation Modals.
     *
     * Used for Custom Heads of Loss.
     *
     * @return {Promise}
     */
    custom: data => endpoint(`${PARENT}/${RESOURCE}`, 'custom', data),
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/interest.js